import { useCallback, useState } from "react";
import AdminLayout from "../../../components/AdminLayout";
import { Cabecalho, Pagina } from "../../../components/AdminLayout/Pagina";
import Abas from "../../../components/Abas";
import ImagemCarregando from "../../../components/ImagemCarregando";
import ListaPaginada from "../Conteudo/ListaPaginada";
import Exclusao from "../Conteudo/Exclusao";
import { Aviso } from "../Conteudo/styled";
import Grupo from "../../../../models/Grupo";
import capa_image from "../../../../assets/capa.png";
import { Corpo } from "./styled";

const ABAS = [
  { id: "todos", rotulo: "Todos", tipo: "" },
  { id: "grupos", rotulo: "Grupos", tipo: "Grupo Principal" },
  { id: "subgrupos", rotulo: "Subgrupos", tipo: "Subgrupo" },
];

const data = (iso) => (iso ? new Date(iso).toLocaleDateString("pt-BR") : "—");
const ehSubgrupo = (g) => g.tipo === "Subgrupo";

// Grupos e SUBGRUPOS da plataforma. O site só lista grupos principais ativos, então um
// subgrupo não aparecia em nenhum lugar do painel. Daqui o administrador vê todos, abre
// o grupo no site e, se for preciso, remove.
export default function Grupos() {
  const [aba, setAba] = useState("todos");
  const [aviso, setAviso] = useState(null);
  const [versao, setVersao] = useState(0);
  const [exclusao, setExclusao] = useState(null);
  const abaAtual = ABAS.find((a) => a.id === aba) || ABAS[0];

  // Nova função só quando a aba muda: o ListaPaginada refaz a consulta quando `listar` muda.
  const listar = useCallback(
    (page, limit, busca) => Grupo.listarParaAdmin(page, limit, { busca, tipo: abaAtual.tipo }),
    [abaAtual.tipo]
  );

  const colunas = [
    { id: "nome", rotulo: "Grupo", largura: "minmax(150px, 2fr)",
      celula: (g) => (
        <div className="grupo-nome">
          <ImagemCarregando className="capa-mini" src={g.foto_capa?.path || capa_image} alt="" />
          <div>
            <span className="nome">{ehSubgrupo(g) && <span className="seta" aria-hidden="true">↳ </span>}{g.nome}</span>
            <span className="meta">{g.estado}{g.status && g.status !== "Ativo" ? ` · ${g.status}` : ""}</span>
          </div>
        </div>
      ) },
    { id: "tipo", rotulo: "Tipo", largura: "92px",
      celula: (g) => <span className={`selo ${ehSubgrupo(g) ? "subgrupo" : "grupo"}`}>{ehSubgrupo(g) ? "Subgrupo" : "Grupo"}</span> },
    { id: "pai", rotulo: "Grupo pai", largura: "minmax(100px, 1.2fr)",
      celula: (g) => (g.grupo_pai
        ? <a className="link" href={`/grupos/${g.grupo_pai.id}`} target="_blank" rel="noopener noreferrer" title="Abrir o grupo pai no site">{g.grupo_pai.nome || `Grupo ${g.grupo_pai.id}`}</a>
        : <span className="meta">{ehSubgrupo(g) ? "não encontrado" : "—"}</span>) },
    { id: "participantes", rotulo: "Participantes", largura: "116px",
      celula: (g) => <span className="nome numero">{g.quantidade_usuarios}</span> },
    { id: "criador", rotulo: "Criado por", largura: "minmax(100px, 1fr)",
      celula: (g) => <span className="meta">{g.criador?.nome || "—"}</span> },
    { id: "criado", rotulo: "Criado em", largura: "104px", celula: (g) => <span className="meta">{data(g.createdAt)}</span> },
    { id: "acoes", rotulo: "Ações", largura: "minmax(124px, auto)", direita: true,
      celula: (g) => (
        <div className="acoes">
          <a href={`/grupos/${g.id}`} target="_blank" rel="noopener noreferrer" aria-label={`Ver ${g.nome} no site (abre em nova aba)`}>Ver</a>
          <button type="button" className="perigo" aria-label={`Remover ${g.nome}`} onClick={() => { setAviso(null); setExclusao(g); }}>Remover</button>
        </div>
      ) },
  ];

  const textosExclusao = exclusao && (ehSubgrupo(exclusao)
    ? { titulo: `Remover o subgrupo "${exclusao.nome}"?`, subtitulo: "Os participantes e todas as postagens do subgrupo serão excluídos de forma permanente. Não dá para desfazer." }
    : { titulo: `Remover o grupo "${exclusao.nome}"?`, subtitulo: "Os subgrupos, os participantes e todas as postagens do grupo serão excluídos de forma permanente. Não dá para desfazer." });

  return (
    <AdminLayout>
      <Pagina>
        <Cabecalho titulo="Grupos" descricao="Todos os grupos e subgrupos da plataforma, com o grupo pai, quem criou e quantos participam." />

        {aviso &&
          <Aviso className={aviso.erro ? "erro" : undefined} role={aviso.erro ? "alert" : "status"}>
            <span>{aviso.texto}</span>
            <button type="button" aria-label="Fechar aviso" onClick={() => setAviso(null)}>×</button>
          </Aviso>
        }

        <Abas abas={ABAS} ativa={aba} onChange={setAba} idBase="grupos-admin" rotulo="Tipo de grupo" />

        <Corpo role="tabpanel" id={`grupos-admin-painel-${aba}`} aria-labelledby={`grupos-admin-${aba}`}>
          <ListaPaginada
            key={aba}
            rotulo="Grupos" listar={listar} colunas={colunas} chave={(g) => `grupo-${g.id}`} versao={versao}
            porPagina={20} itens="grupos"
            textoBusca="Buscar por nome, estado ou criador" placeholderBusca=""
            vazio={aba === "subgrupos" ? "Ainda não há subgrupos." : "Ainda não há grupos."}
            larguraMinima={860}
          />
        </Corpo>

        {exclusao &&
          <Exclusao
            item={exclusao} excluir={Grupo.delete} textoBotao="Remover"
            titulo={textosExclusao.titulo} subtitulo={textosExclusao.subtitulo}
            onCancelar={() => setExclusao(null)}
            onExcluido={() => { setExclusao(null); setAviso({ texto: ehSubgrupo(exclusao) ? "Subgrupo removido." : "Grupo removido, junto com seus subgrupos." }); setVersao((v) => v + 1); }}
          />
        }
      </Pagina>
    </AdminLayout>
  );
}
